import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface GlobalAction {
  type: string;
  payload?: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalActionsService {
  private actionSubject = new Subject<GlobalAction>();
  public action$ = this.actionSubject.asObservable();

  triggerAction(action: GlobalAction): void {
    this.actionSubject.next(action);
  }
}